import useLoadDevicePhoto from '../../utils/hooks/useLoadDevicePhoto'

import useStyles from './index.styles'

const DeviceThumbnail = ({ deviceId }: { deviceId: number }) => {
  const classes = useStyles
  const { photoPath } = useLoadDevicePhoto(deviceId, true, 'thumb')

  if (photoPath) return <img src={photoPath} alt="Photo of device" width="120" height="120" style={classes.deviceThumbnail} />
  return null
}

export default DeviceThumbnail
